import { StateCreator } from 'zustand';

import { fetchBonanzaPromoMenuCMS } from '@/api/cms';
import { BonanzaPromoStatus } from '@/modules/promotions';
import { BonanzaPromoState, CommonStoreType } from '@/store/commonStore/types';

export const useBonanzaPromoSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  BonanzaPromoState
> = (set) => {
  return {
    userBonanzaGroup: BonanzaPromoStatus.LEVEL_0,
    userBonanzaGroupKey: '',
    bonanzaReward: '',
    bonanzaProgressPercent: 0,
    bonanzaPromoMenuData: null,
    pendingBonanzaPromoMenuData: false,
    fetchBonanzaPromoMenuData: async (locale: string) => {
      try {
        set({ pendingBonanzaPromoMenuData: true });
        const { data } = await fetchBonanzaPromoMenuCMS(locale);

        set({ bonanzaPromoMenuData: data || null });
      } catch (error) {
        console.log(error);
      } finally {
        set({ pendingBonanzaPromoMenuData: false });
      }
    },
  };
};
